import React, { useState, useEffect } from "react";
import { setInputValues } from "../../utils/AnayliticsFunctionality";
import { Button } from "../actions/Button";
import { useToast } from "../../components/CustomToast";
import { useAssumptions } from "../../AssumptionsContext";

function AnalyticsCard01({
  roe,
  setRoe,
  revGrowth,
  setRevGrowth,
  profitMargin,
  setProfitMargin,
  fcfMargin,
  setFcfMargin,
  pe,
  setPeRatios,
  pfcf,
  setpfcf,
  handleAnalyser,
  selectedYear,
  selectedAssumptionEntries,
}) {
  const { addToast } = useToast();
  const [assumptionInputs, setAssumptionInputs] = useState([
    {
      label: (
        <div className="flex items-center group relative cursor-help">
          ROE
          <svg
            className="w-4 h-4 ml-1 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <div className="invisible group-hover:visible absolute left-0 top-full mt-2 w-64 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg z-50">
            Return on Equity (Egenkapitalforrentning) - Måler hvor effektivt en
            virksomhed bruger sine aktionærers investeringer til at generere
            overskud
          </div>
        </div>
      ),
      historical: {
        oneYear: "-",
      },
      hasInput: false,
      state: roe,
      type: "roe",
    },
    {
      label: (
        <div className="flex items-center group relative cursor-help">
          Omsætningsvækst (%)
          <svg
            className="w-4 h-4 ml-1 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <div className="invisible group-hover:visible absolute left-0 top-full mt-2 w-64 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg z-50">
            Den procentvise stigning i virksomhedens samlede salg over en given
            periode
          </div>
        </div>
      ),
      historical: {
        oneYear: "-",
        threeYears: "-",
      },
      hasInput: true,
      state: revGrowth,
      type: "revGrowth",
    },
    {
      label: (
        <div className="flex items-center group relative cursor-help">
          Overskudsgrad (%)
          <svg
            className="w-4 h-4 ml-1 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <div className="invisible group-hover:visible absolute left-0 top-full mt-2 w-64 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg z-50">
            Procentdelen af omsætningen der bliver til overskud efter alle
            omkostninger er betalt
          </div>
        </div>
      ),
      historical: {
        oneYear: "-",
        threeYears: "-",
      },
      hasInput: true,
      state: profitMargin,
      type: "profitMargin",
    },
    {
      label: (
        <div className="flex items-center group relative cursor-help">
          P/E
          <svg
            className="w-4 h-4 ml-1 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <div className="invisible group-hover:visible absolute left-0 top-full mt-2 w-64 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg z-50">
            Price/Earnings (Pris/Indtjening) - Aktiekurs divideret med
            indtjening per aktie. Indikerer hvor mange år det ville tage at tjene
            investeringen tilbage
          </div>
        </div>
      ),
      historical: {
        oneYear: "-",
        threeYears: "-",
      },
      hasInput: true,
      state: pe,
      type: "pe",
    },
    {
      label: (
        <div className="flex items-center group relative cursor-help">
          Pengestrømsmargin (%)
          <svg
            className="w-4 h-4 ml-1 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <div className="invisible group-hover:visible absolute left-0 top-full mt-2 w-64 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg z-50">
            Den procentdel af omsætningen der bliver til frie pengestrømme efter
            alle driftsomkostninger og investeringer
          </div>
        </div>
      ),
      historical: {
        oneYear: "-",
        threeYears: "-",
      },
      hasInput: true,
      state: fcfMargin || { inputs: { low: "", mid: "" } },
      type: "fcfMargin",
    },
    {
      label: (
        <div className="flex items-center group relative cursor-help">
          P/FCF
          <svg
            className="w-4 h-4 ml-1 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <div className="invisible group-hover:visible absolute left-0 top-full mt-2 w-64 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg z-50">
            Price/Free Cash Flow (Pris/Frit Cash Flow) - Aktiekurs i forhold til
            frit cash flow per aktie. Viser hvor mange år det ville tage at
            generere den nuværende markedsværdi i frie pengestrømme
          </div>
        </div>
      ),
      historical: {
        oneYear: "-",
        threeYears: "-",
      },
      hasInput: true,
      state: pfcf || { inputs: { low: "", mid: "" } },
      type: "pfcf",
    },
  ]);

  useEffect(() => {
    console.log("ROE State:", roe);
    console.log("Assumption Inputs:", assumptionInputs);
  }, [roe, assumptionInputs]);



  useEffect(() => {
    setAssumptionInputs((prev) =>
      prev.map((metric) => {
        switch (metric.type) {
          case "roe":
            return {
              ...metric,
              historical: {
                oneYear: roe?.firstYearROE || "-",
              },
              state: roe,
            };
          case "revGrowth":
            return {
              ...metric,
              historical: {
                oneYear: revGrowth?.firstYearRevGrowth || "-",
                threeYears: revGrowth?.threeYearRevGrowth || "-",
              },
              state: revGrowth,
            };
          case "profitMargin":
            return {
              ...metric,
              historical: {
                oneYear: profitMargin?.firstYearProfitMargin || "-",
                threeYears: profitMargin?.threeYearProfitMargin || "-",
              },
              state: profitMargin,
            };
          case "fcfMargin":
            return {
              ...metric,
              historical: {
                oneYear: fcfMargin?.firstYearFcfMargin || "-",
                threeYears: fcfMargin?.threeYearFcfMargin || "-",
              },
              state: fcfMargin,
            };
          case "pe":
            return {
              ...metric,
              historical: {
                oneYear: pe?.firstYearPeRatios || "-",
                threeYears: pe?.threeYearPE || "-",
              },
              state: pe,
            };
          case "pfcf":
            return {
              ...metric,
              historical: {
                oneYear: pfcf?.firstYearPFCF || "-",
                threeYears: pfcf?.threeYearPFCF || "-",
              },
              state: pfcf,
            };
          default:
            return metric;
        }
      })
    );
  }, [roe, revGrowth, profitMargin, fcfMargin, pe, pfcf]);

  const validateInputs = () => {
    for (const metric of assumptionInputs) {
      if (metric.hasInput === true) {
        const inputs = metric?.state?.inputs;
        if (!inputs) {
          addToast(`Manglende input værdier`, "error");
          return false;
        }
  
        // Validate numeric values
        const { low, mid } = inputs;
        if (selectedAssumptionEntries === 0) {
          if (!isValidNumber(low)) {
            addToast(`Ugyldig værdi i ${metric.type}`, "error");
            return false;
          }
        } else {
          if (!isValidNumber(low) || !isValidNumber(mid)) {
            addToast(`Ugyldig værdi i ${metric.type}`, "error");
            return false;
          }
        }
      }
    }
    return true;
  };
  
  const isValidNumber = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && value !== "" && num !== 0;
  };

  const handleAnalyserClick = () => {
    if (validateInputs()) {
      // Log values before analysis
      console.log('Analysis inputs:', {
        revGrowth: revGrowth.inputs,
        profitMargin: profitMargin.inputs,
        pe: pe.inputs,
        selectedYear
      });
      
      // Ensure selectedYear is passed as a number
      const year = parseInt(selectedYear, 10);
      
      // Call handleAnalyser with validated inputs
      handleAnalyser(year);
    }
  };

  return (
    <div className="flex flex-col col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl p-4 sm:p-6 w-15/15 sm:w-auto mx-auto sm:mx-0">
      {/* Header */}
      <header className="px-2 sm:px-5 py-3 sm:py-4 border-b border-gray-100 dark:border-gray-700/60">
        <div className="flex flex-row items-center justify-between gap-1 sm:gap-0">
          <h2 className="font-semibold text-gray-800 dark:text-gray-100 w-1/4 sm:w-1/5 text-[10px] sm:text-sm">
            Målinger
          </h2>
          <h2 className="font-semibold text-gray-800 dark:text-gray-100 w-1/3 text-[10px] sm:text-sm">
            Historisk data
          </h2>
          <h2 className="font-semibold text-gray-800 dark:text-gray-100 w-1/3 text-[10px] sm:text-sm">
            Mine forventninger
          </h2>
        </div>
      </header>

      {/* Subheader for Historical and My Assumptions */}
      <div className="flex justify-between mt-4 text-xs text-gray-500">
        <div className="w-1/5"></div>
        <div className="w-3/12 flex justify-between">
          <div className="relative group flex items-center gap-1">
            <div>1 år</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-gray-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
            <div className="absolute invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 text-xs text-white bg-gray-900 rounded-lg whitespace-nowrap">
              Udregning basseret på årsrapportering sammenlignet med sidste års
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1 border-8 border-transparent border-t-gray-900"></div>
            </div>
          </div>

          <div className="relative group flex items-center gap-1">
            <div>3 år</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-gray-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
            <div className="absolute invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 bottom-full left-1/2 transform -translate-x-1/2 -mt-1 border-8 border-transparent border-t-gray-900"></div>
          </div>
        </div>

        {selectedAssumptionEntries === 0 ? (
          <div className="w-1/3 flex justify-around">
            <div>Lav</div>
          </div>
        ) : selectedAssumptionEntries === 1 ? (
          <div className="w-1/3 flex justify-around">
            <div>Lav</div>
            <div>Høj</div>
          </div>
        ) : (
          <div className="w-1/3 flex justify-around">
            <div>Lav</div>
            <div>Høj</div>
          </div>
        )}
      </div>

      {/* Table-like layout with metrics, historical data, and user input */}
      <div className="mt-6">
        {assumptionInputs ? (
          assumptionInputs.map((metric, index) => {
            return (
              <div
                key={index}
                className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-gray-700/60"
              >
                <div className="w-1/5 text-gray-800 dark:text-gray-100 text-[11px] sm:text-sm">
                  {metric.label}
                </div>
                <div className="w-3/12 flex justify-between text-gray-800 dark:text-gray-100 text-[11px] sm:text-sm">
                  <div>
                    {metric.historical.oneYear}
                    {metric.type !== "pe" && metric.type !== "pfcf" ? "%" : ""}{" "}
                  </div>
                  <div>
                    {metric.historical.threeYears}
                    {metric.historical.threeYears
                      ? metric.type !== "pe" && metric.type !== "pfcf"
                        ? "%"
                        : ""
                      : ""}{" "}
                  </div>
                </div>

                {/* Inputs */}
                {metric.hasInput ? (
                  <>
                    {selectedAssumptionEntries === 0 ? (
                      <div className="w-1/3 flex justify-around gap-2.5">
                        <input
                          type="number"
                          name="low"
                          value={metric.state.inputs?.low || ""}
                          onChange={(e) => {
                            const { value } = e.target;
                            setInputValues(
                              metric.type,
                              value,
                              "low",
                              setRoe,
                              setRevGrowth,
                              setProfitMargin,
                              setFcfMargin,
                              setPeRatios,
                              setpfcf
                            );
                          }}
                          className="w-2/3 sm:w-1/3 text-center border border-gray-300 rounded-md text-[11px] sm:text-sm"
                        />
                      </div>
                    ) : (
                      <div className="w-1/3 flex justify-around gap-2.5">
                        <input
                          type="number"
                          name="low"
                          value={metric.state.inputs?.low || ""}
                          onChange={(e) => {
                            const { value } = e.target;
                            setInputValues(
                              metric.type,
                              value,
                              "low",
                              setRoe,
                              setRevGrowth,
                              setProfitMargin,
                              setFcfMargin,
                              setPeRatios,
                              setpfcf
                            );
                          }}
                          className="w-2/3 sm:w-1/3 text-center border border-gray-300 rounded-md text-[11px] sm:text-sm"
                        />
                        <input
                          type="number"
                          name="mid"
                          value={metric.state.inputs?.mid || ""}
                          onChange={(e) => {
                            const { value } = e.target;
                            setInputValues(
                              metric.type,
                              value,
                              "mid",
                              setRoe,
                              setRevGrowth,
                              setProfitMargin,
                              setFcfMargin,
                              setPeRatios,
                              setpfcf
                            );
                          }}
                          className="w-2/3 sm:w-1/3 text-center border border-gray-300 rounded-md text-[11px] sm:text-sm"
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="w-1/3 flex justify-around gap-2.5"></div>
                )}
              </div>
            );
          })
        ) : (
          <div>Loading...</div>
        )}
      </div>

      <div className="flex justify-end mt-3">
        <Button
          onClick={() => handleAnalyserClick()}
          text="Analyser"
          variant="primary"
          size="md"
        />
      </div>
    </div>
  );
}

export default AnalyticsCard01;